<script>
let ymapsScriptPromise = null;

export default {
    name: 'MapComponent',

    data() {
        return {
            _observer: null,
            _map: null,
            _timeout: null,
            _inited: false,
            _destroyed: false,

            center: [41.649730, 41.640445],
            zoom: 16,
            yandexMapLink: 'https://yandex.com.ge/maps/-/CPgGV29g',
        };
    },

    mounted() {
        const el = this.$refs.map;
        if (!el) return;

        const tryInit = () => {
            if (this._destroyed || this._inited) return false;

            const r = el.getBoundingClientRect();

            if (r.width > 0 && r.height > 0) {
                this._observer?.disconnect();
                this._observer = null;
                this.loadMap();
                return true;
            }

            return false;
        };

        this._observer = new IntersectionObserver(
            (entries) => entries.forEach((e) => e.isIntersecting && tryInit()),
            { threshold: 0.1 }
        );

        this._observer.observe(el);

        this._timeout = setTimeout(() => {
            tryInit();
        }, 1500);
    },

    beforeUnmount() {
        this._destroyed = true;

        this._observer?.disconnect();
        this._observer = null;

        if (this._timeout) {
            clearTimeout(this._timeout);
            this._timeout = null;
        }

        try {
            if (this._map && typeof this._map.destroy === 'function') {
                this._map.destroy();
            }
        } catch (e) {
            console.warn('Yandex map destroy skipped:', e);
        }

        this._map = null;
    },

    methods: {
        async loadMap() {
            if (this._inited || this._destroyed) return;

            this._inited = true;

            try {
                await this._loadYandexMapsScript();

                if (this._destroyed || !this.$refs.map) return;

                await new Promise((resolve) => window.ymaps.ready(resolve));

                if (this._destroyed || !this.$refs.map) return;

                const map = new window.ymaps.Map(
                    this.$refs.map,
                    {
                        center: this.center,
                        zoom: this.zoom,
                        controls: ['zoomControl'],
                    },
                    {
                        suppressMapOpenBlock: true,
                    }
                );

                map.behaviors.disable('scrollZoom');

                const mainPlacemark = new window.ymaps.Placemark(
                    this.center,
                    {
                        hintContent: 'Mazniashvili 21-23',
                        balloonContent: 'Mazniashvili 21-23, Batumi',
                    },
                    {
                        preset: 'islands#blackDotIcon',
                        cursor: 'pointer',
                    }
                );

                mainPlacemark.events.add('click', () => {
                    window.open(this.yandexMapLink, '_blank');
                });

                map.geoObjects.add(mainPlacemark);
                map.container.fitToViewport();

                this._map = map;
            } catch (e) {
                console.warn('Yandex map init failed:', e);
            }
        },

        _loadYandexMapsScript() {
            if (window.ymaps?.ready) {
                return Promise.resolve();
            }

            if (ymapsScriptPromise) {
                return ymapsScriptPromise;
            }

            ymapsScriptPromise = new Promise((resolve, reject) => {
                const s = document.createElement('script');

                s.src = 'https://api-maps.yandex.ru/2.1/?apikey=ТВОЙ_API_KEY&lang=en_US';
                s.async = true;
                s.defer = true;
                s.dataset.ymaps = 'true';

                s.onload = resolve;
                s.onerror = reject;

                document.head.appendChild(s);
            });

            return ymapsScriptPromise;
        },
    },
};
</script>

<template>
    <div
        ref="map"
        class="h-64 w-full overflow-hidden rounded-2xl"
    />
</template>
